import React from 'react';

import ParenthoodFilter from './ParenthoodFilter';
import SchooltypesFilter from './SchooltypesFilter';
import SchoolyearsFilter from './SchoolyearsFilter';
import LocationsFilter from './LocationsFilter';
import ProductsFilter from './ProductsFilter';


class FiltersToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.ITEM_TYPE_PRODUCT_GROUP = 'group';
    this.ITEM_TYPE_PRODUCT = 'product';

    let productItems = []; // this is a merge of both product groups and products
    if (this.props.data.productGroups && this.props.data.productGroups.length) {
      this.props.data.productGroups.forEach((id) => {
        productItems.push({
          type: this.ITEM_TYPE_PRODUCT_GROUP,
          id: id
        });
      });
    }
    if (this.props.data.products && this.props.data.products.length) {
      this.props.data.products.forEach((id) => {
        productItems.push({
          type: this.ITEM_TYPE_PRODUCT,
          id: id
        });
      });
    }

    this.state = {
      open: this.props.collapsable ? false : true,

      productItems
    };

    this.toggle = this.toggle.bind(this);

    this.handleParenthoodChange = this.handleParenthoodChange.bind(this);
    this.handleSchooltypesChange = this.handleSchooltypesChange.bind(this);

    this.toggleAllSchoolyears = this.toggleAllSchoolyears.bind(this);
    this.handleSchoolyearsChange = this.handleSchoolyearsChange.bind(this);

    this.handleAddLocationDropdown = this.handleAddLocationDropdown.bind(this);
    this.handleSetLocation = this.handleSetLocation.bind(this);
    this.handleRemoveLocation = this.handleRemoveLocation.bind(this);

    this.handleAddProductDropdown = this.handleAddProductDropdown.bind(this);
    this.handleSetProduct = this.handleSetProduct.bind(this);
    this.handleRemoveProduct = this.handleRemoveProduct.bind(this);

    this.handleChangeOperator = this.handleChangeOperator.bind(this);

    this.execOnChange = this.execOnChange.bind(this); // single callback to props.onChange
  }

  toggle() {
    if (!this.props.collapsable) {
      return;
    }

    this.setState({
      open: !this.state.open
    });
  }

  handleParenthoodChange(relationships) {
    if (this.execOnChange) {
      if (!this.props.data) {
        alert('No data passed to filters');

        return false;
      }

      const data = Object.assign(this.props.data, {relationships});

      this.execOnChange(data);
    }
  }

  handleSchooltypesChange(schooltypes) {
    if (this.execOnChange) {
      if (!this.props.data) {
        alert('No data passed to filters');

        return false;
      }

      const data = Object.assign(this.props.data, {schooltypes});

      this.execOnChange(data);
    }
  }

  toggleAllSchoolyears() {
    let schoolyears = [];
    for (let y=2010; y<=(new Date()).getFullYear(); y++) {
      schoolyears.push(y);
    }

    if (this.props.data && this.props.data.schoolyears.join(',') == schoolyears.join(',')) {
      schoolyears = [];
    }

    this.handleSchoolyearsChange(schoolyears);
  }

  handleSchoolyearsChange(schoolyears) {
    if (this.execOnChange) {
      if (!this.props.data) {
        alert('No data passed to filters');

        return false;
      }

      const data = Object.assign(this.props.data, {schoolyears});

      this.execOnChange(data);
    }
  }

  handleAddLocationDropdown() {
    let locations = this.props.data.locations;

    locations.push(''); // just add empty item to array

    this.execOnChange(Object.assign(this.props.data, {locations}));
  }
  handleSetLocation(locationId, index) {
    let locations = this.props.data.locations;

    if (locationId) {
      locations[index] = locationId;
    } else {
      locations.splice(index, 1);
    }

      this.execOnChange(Object.assign(this.props.data, {locations}));
  }
  handleRemoveLocation(index) {
    this.handleSetLocation(null, index);
  }

  handleAddProductDropdown() {
    this.setState((prevState) => {
      prevState.productItems.push({}); // just add empty item to array

      return prevState;
    })
    let products = this.props.data.products;

    products.push('');

    this.execOnChange(Object.assign(this.props.data, {products}));
  }
  handleSetProduct(type, itemId, index) {
    const items = this.state.productItems;

    if (itemId) {
      items[index] = {
        type: type,
        id: itemId
      };
    } else {
      items.splice(index, 1);
    }

    let products = [];
    let productGroups = [];
    items.forEach((item) => {
      if (item.type == this.ITEM_TYPE_PRODUCT_GROUP) {
        productGroups.push(item.id);
      }
      if (item.type == this.ITEM_TYPE_PRODUCT) {
        products.push(item.id);
      }
    });

    this.execOnChange(Object.assign(this.props.data, {productGroups, products}));
  }
  handleRemoveProduct(type, index) {
    this.handleSetProduct(null, null, index);
  }

  handleChangeOperator(index, value) {
    let operators = this.props.data.operators ? this.props.data.operators : [];

    operators[index] = value;

    this.execOnChange(Object.assign(this.props.data, {operators}));
  }

  execOnChange(data) {
    // check if "OR" is still valid whenever we change something, and override if not
    const operator1Enabled = data.locations.join('') && data.schoolyears.join('');
    const operator2Enabled = (data.locations.join('') || data.schoolyears.join('')) && (data.productGroups.join('') || data.products.join('') || data.projects.join(''));

    let operators = data.operators ? data.operators : [];

    if (!operator1Enabled) {
      operators[0] = 'AND';
    }
    if (!operator2Enabled) {
      operators[1] = 'AND';
    }

    this.props.onChange(Object.assign(data, {operators}));
  }

  render() {
    const filterData = this.props.data;

    let statusMessage = '';
    if (filterData.relationships && filterData.relationships.join('')) {
      statusMessage += filterData.relationships.length + ' ' + (filterData.relationships.length == 1 ? 'tipologia' : 'tipologie');
    }
    if (filterData.schooltypes && filterData.schooltypes.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.schooltypes.length + ' ' + (filterData.schooltypes.length == 1 ? 'ordine scolastico' : 'ordini scolastici');
    }
    if (filterData.schoolyears && filterData.schoolyears.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.schoolyears.length + ' ' + (filterData.schoolyears.length == 1 ? 'anno scolastico' : 'anni scolastici');
    }
    if (filterData.locations && filterData.locations.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.locations.length + ' località';
    }
    if (filterData.productGroups && filterData.productGroups.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.productGroups.length + ' ' + (filterData.productGroups.length == 1 ? 'gruppo prodotto' : 'gruppi prodotto');
    }
    if (filterData.products && filterData.products.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.products.length + ' ' + (filterData.products.length == 1 ? 'prodotto' : 'prodotti');
    }
    if (filterData.projects && filterData.projects.join('')) {
      statusMessage += (statusMessage ? ' + ' : '') + filterData.projects.length + ' ' + (filterData.projects.length == 1 ? 'progetto' : 'progetti');
    }

    const operator1Enabled = filterData.locations.join('') && filterData.schoolyears.join('');
    const operator2Enabled = (filterData.schoolyears.join('') || filterData.locations.join('')) && (filterData.productGroups.join('') || filterData.products.join('') || filterData.projects.join(''));

    return (
      <div className="container mb-4" style={{backgroundColor: '#dedede', paddingTop: '0.75rem', paddingBottom: '0.75rem', border: '1px solid #d6d6d6', borderRadius: '0.3rem'}}>
        <div className="row">
          <div className="col-12">
            {/* Header */}
            <div style={this.props.collapsable ? {cursor: 'pointer'} : {}} onClick={this.toggle}>
              {
                this.props.collapsable ? (
                  <div style={{position: 'absolute', top: this.state.open ? '0.25rem' : '0.5rem', right: '20px'}}>
                    <a href="javascript:void(0);">
                      <i className={this.state.open ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{fontSize: '1.25remZ', color: '#aaa'}} />
                    </a>
                  </div>
                ) : ''
              }
              <h3><i className="fa fa-filter" /> Filtra <small>({statusMessage || 'nessun filtro'})</small></h3>
            </div>

            {/* Filters */}
            <div className={'animated-plus ' + (this.state.open ? 'slideDown' : 'slideUp')}>
              {/* Plesso/IC */}
              {
                this.props.filters.indexOf('parenthood') === -1 ? '' : (
                  <div>
                    <h4 className="mt-4 mb-4">Plesso/I.C. <small className="text-muted">– filtra per tipologia (plesso/I.C.)</small></h4>

                    <ParenthoodFilter
                      appData={this.props.appData}

                      value={filterData.relationships}
                      onChange={this.handleParenthoodChange}
                    />

                    {/* <div className="mt-4" style={{width: '250px'}}>
                      <hr />
                      <select className="form-control" disabled={operator2Enabled == false ? 'disabled' : null} style={{width: '120px'}} value={this.props.data.operators[1]} onChange={(e) => {this.handleChangeOperator(1, e.currentTarget.value)}}>
                        <option value="AND">AND</option>
                        {operator2Enabled ? <option value="OR">OR</option> : ''}
                      </select>
                      <hr />
                    </div> */}
                  </div>
                )
              }

              {/* School types */}
              {
                this.props.filters.indexOf('schooltypes') === -1 ? '' : (
                  <div>
                    {this.props.filters.indexOf('parenthood') !== -1 ? <hr /> : ''}

                    <h4 className="mt-4 mb-4">Ordine scolastico <small className="text-muted">– filtra per tipo di scuola</small></h4>

                    <SchooltypesFilter
                      appData={this.props.appData}

                      value={filterData.schooltypes}
                      onChange={this.handleSchooltypesChange}
                    />

                    {/* <div className="mt-4" style={{width: '250px'}}>
                      <hr />
                      <select className="form-control" disabled={operator2Enabled == false ? 'disabled' : null} style={{width: '120px'}} value={this.props.data.operators[1]} onChange={(e) => {this.handleChangeOperator(1, e.currentTarget.value)}}>
                        <option value="AND">AND</option>
                        {operator2Enabled ? <option value="OR">OR</option> : ''}
                      </select>
                      <hr />
                    </div> */}
                  </div>
                )
              }

              {/* Location */}
              {
                this.props.filters.indexOf('locations') === -1 ? '' : (
                  <div>
                    {this.props.filters.indexOf('schooltypes') !== -1 ? <hr /> : ''}

                    <h4 className="mt-4 mb-4">Localit&agrave; <small className="text-muted">– filtra per regione/provincia/comune</small></h4>
                    <div>
                      {
                        filterData.locations.length ? (
                          filterData.locations.map((locationId, i) => {
                            return (
                              <div className="float-left mt-0 mb-1 mr-2">
                                <div className="float-left" style={{minWidth: '320px'}}>
                                  <LocationsFilter
                                    appData={this.props.appData}

                                    value={locationId}

                                    onChange={(locationId) => this.handleSetLocation(locationId, i)}
                                  />
                                </div>

                                <div className="float-left ml-1">
                                  <a href="javascript:void(0);" className="btn btn-secondary" style={{backgroundColor: '#fff', borderColor: '#bcbcbc'}} onClick={() => this.handleRemoveLocation(i)}>
                                    <i className="fa fa-times" style={{color: '#ccc'}} />
                                  </a>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <h5 className="float-left mr-2" style={{lineHeight: '2.2rem'}}>Qualsiasi località</h5>
                        )
                      }

                      <div className="float-left ml-2">
                        <a href="javascript:void(0);" className="btn btn-secondary" style={{backgroundColor: '#fff', borderColor: '#bcbcbc'}} onClick={this.handleAddLocationDropdown}>
                          <i className="fa fa-plus" style={{color: '#ccc'}} />
                        </a>
                      </div>

                      <div className="clearfix" />
                    </div>
                  </div>
                )
              }

              {/* <div className="mt-4" style={{width: '250px'}}>
                <hr />
                <select className="form-control" disabled={operator1Enabled == false ? 'disabled' : null} style={{width: '120px'}} value={this.props.data.operators[0]} onChange={(e) => {this.handleChangeOperator(0, e.currentTarget.value)}}>
                  <option value="AND">AND</option>
                  {operator1Enabled ? <option value="OR">OR</option> : ''}
                </select>
              </div> */}

              {/* Schoolyear */}
              {
                this.props.filters.indexOf('schoolyears') === -1 ? '' : (
                  <div>
                    {this.props.filters.indexOf('locations') !== -1 ? <hr /> : ''}

                    <h4 className="mt-4 mb-4">
                      Anno scolastico: <small className="text-muted">– filtra per anno scolastico</small>
                      <span className="float-right">
                        <button className="btn btn-sm btn-secondary" onClick={this.toggleAllSchoolyears}>Cambia tutti</button>
                      </span>
                      <div className="clearfix" />
                    </h4>

                    <SchoolyearsFilter
                      appData={this.props.appData}

                      value={filterData.schoolyears}
                      onChange={this.handleSchoolyearsChange}
                    />

                    {/* <div className="mt-4" style={{width: '250px'}}>
                      <hr />
                      <select className="form-control" disabled={operator2Enabled == false ? 'disabled' : null} style={{width: '120px'}} value={this.props.data.operators[1]} onChange={(e) => {this.handleChangeOperator(1, e.currentTarget.value)}}>
                        <option value="AND">AND</option>
                        {operator2Enabled ? <option value="OR">OR</option> : ''}
                      </select>
                      <hr />
                    </div> */}
                  </div>
                )
              }

              {/* x prodotto */}
              {
                this.props.filters.indexOf('projects') === -1 && this.props.filters.indexOf('products') === -1 ? '' : (
                  <div>
                    {this.props.filters.indexOf('schoolyears') !== -1 ? <hr /> : ''}

                    <h4 className="mt-4 mb-4">Progetti/prodotti: <small className="text-muted">– filtra da progetto/prodotto/kit</small></h4>

                    <div>
                      {
                        this.state.productItems.length ? (
                          this.state.productItems.map((item, i) => {
                            return (
                              <div className="float-left mt-0 mb-1 mr-2">
                                <div className="float-left" style={{minWidth: '320px'}}>
                                  <ProductsFilter
                                    appData={this.props.appData}

                                    value={item.id}

                                    onChange={(type, itemId) => this.handleSetProduct(type, itemId, i)}
                                  />
                                </div>

                                <div className="float-left ml-1">
                                  <a href="javascript:void(0);" className="btn btn-secondary" style={{backgroundColor: '#fff', borderColor: '#bcbcbc'}} onClick={() => this.handleRemoveProduct(item.type, i)}>
                                    <i className="fa fa-times" style={{color: '#ccc'}} />
                                  </a>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <h5 className="float-left mr-2" style={{lineHeight: '2.2rem'}}>Tutti i progetti/prodotti</h5>
                        )
                      }

                      <div className="float-left ml-2">
                        <a href="javascript:void(0);" className="btn btn-secondary" style={{backgroundColor: '#fff', borderColor: '#bcbcbc'}} onClick={this.handleAddProductDropdown}>
                          <i className="fa fa-plus" style={{color: '#ccc'}} />
                        </a>
                      </div>

                      <div className="clearfix" />
                    </div>
                  </div>
                )
              }

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FiltersToolbar;


// WEBPACK FOOTER //
// ./src/components/shared/filters/FiltersToolbar.js